import { Title } from '@common/components/Title';
import { useSelectedCollectionMetadata } from '@features/Collection/hooks';
import { Flex, Skeleton } from '@radix-ui/themes';

export const TitleBlock = () => {
    const { data: metadata, isLoading } = useSelectedCollectionMetadata();
    const title = metadata.title;

    return (
        <Flex gap={'2'} align={'center'}>
            <Title mb={'0'} size={'8'}>
                <Skeleton loading={isLoading}>{title}</Skeleton>
            </Title>
        </Flex>
    );
};
